import React from 'react'
import { View, Text, StyleSheet } from '@react-pdf/renderer'
import { OpForPDFType } from '../Modals/ViewPCP/GeneratePDFModal'

const styles = StyleSheet.create({
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#f0f0f0',
    borderBottomWidth: 1,
    borderBottomColor: '#ccc',
    marginBottom: 5,
  },
  tableHeaderCell: {
    fontSize: 9,
    fontWeight: 'bold',
    textAlign: 'center',
    padding: 8,
    flex: 1,
    borderRightWidth: 1,
    borderRightColor: '#ccc',
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#eee',
    minHeight: 30,
  },
  tableCell: {
    fontSize: 8,
    textAlign: 'left',
    padding: 8,
    flex: 1,
    borderRightWidth: 1,
    borderRightColor: '#eee',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    wordWrap: 'break-word',
    overflow: 'hidden',
  }
})


interface TableDataProps {
  tableHeaders: string[]
  tableData: Array<Array<{value: string, type?: 'string' | 'image'}>>
}

const TableOfPDF: React.FC<TableDataProps> = ({ tableData, tableHeaders }) => {
  return (
    <>
      <View style={styles.tableHeader}>
        {tableHeaders.map((header, index) => 
          <Text style={styles.tableHeaderCell} key={index}>{header}</Text>
        )}
      </View>
        {tableData.map((row, index) => 
          <View key={index} style={styles.tableRow} wrap={false}>
            {row.map((cell, index) => 
              <Text style={styles.tableCell} key={index}>{cell.value}</Text>
            )}
          </View>
        )}
    </>
  )
}

export default TableOfPDF